exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comp-parts-verify[data-v-71f10564]{margin:20px 0 40px;padding:40px 20px;background-color:hsla(0,0%,93%,.5);border-radius:4px}@media only screen and (min-width:40.063em){.comp-parts-verify[data-v-71f10564]{margin:40px 0 80px;padding:60px 76px}}@media only screen and (min-width:64.063em){.comp-parts-verify[data-v-71f10564]{margin:40px 0 160px;padding:80px 154px}}.comp-parts-verify__subheader[data-v-71f10564]{margin-bottom:25px;font-family:Open Sans,sans-serif;font-weight:700;font-size:16px;line-height:1.4;text-transform:uppercase;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:text}.comp-parts-verify__message[data-v-71f10564]{margin-bottom:22px;font-size:18px;line-height:25px;color:#424242}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71f10564","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/verify/email/Email.vue
// module id = 0694323c541557e88671
// module chunks = 26